import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { DefaultFormAutocomplete } from "../../../../../../common/components/default_form_autocomplete";
import { useCallback, useEffect } from "react";
import { UseFormReturn } from "react-hook-form";
import { FormSelectInput } from "../../../../../../common/components/masked_inputs/react_forms/form_select_input";

import PrimaryButton from "../../../../../../common/components/primary_button";
import FormContainer from "../../../../../../common/components/form_container";
import dayjs from "dayjs";
import { TreinamentoFuncionarioData } from "../../../../../rh/domain/models/treinamento_funcionario_data";
import { TreinamentoFuncionarioInstrutor } from "../../../../../rh/domain/models/treinamento_funcionario_instrutor";
import { TreinamentoFuncionarioLocal } from "../../../../../rh/domain/models/treinamento_funcionario_local";
import { ReportTreinamentoFuncionarioForm } from "../../../../../rh/presentation/schemas/TreinamentoFuncionario_cadastro/report_treinamento_funcionario";


type Props = {
  open: boolean,
  saving: boolean,
  datas: TreinamentoFuncionarioData[],
  instrutores: TreinamentoFuncionarioInstrutor[],
  locais: TreinamentoFuncionarioLocal[],
  reactHookForm: UseFormReturn<ReportTreinamentoFuncionarioForm>,
  onSubmit: (form: any) => void,
  onClose: () => void,
};

export const ReportListaTreinamentosModal = ({
  open,
  saving,
  datas,
  instrutores,
  locais,
  reactHookForm,
  onSubmit,
  onClose,
}: Props) => {

  // 1. Observa os valores para fazer o "IF"
  const dataRealizacaoSelected = reactHookForm.watch('dataRealizacao');
  const instrutorSelected = reactHookForm.watch('instrutor');

  useEffect(() => {
    if (open) reactHookForm.reset({ conteudoProgramatico: 0 });
  }, [open, reactHookForm]);

  // 2. Limpa os campos filhos se o pai for limpo (opcional, mas evita dados sujos)
  useEffect(() => {
    if (!dataRealizacaoSelected) {
        reactHookForm.setValue('instrutor', "");
        reactHookForm.setValue('local', "");
    }
  }, [dataRealizacaoSelected, reactHookForm]);

  useEffect(() => {
    if (!instrutorSelected) {
        reactHookForm.setValue('local', "");
    }
  }, [instrutorSelected, reactHookForm]);

  const handleClose = useCallback(() => {
    if (!saving) onClose();
  }, [saving, onClose]);

  return (
    <Dialog
      open={open}
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: reactHookForm.handleSubmit(onSubmit),
        }
      }}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "40rem",
          },
        },
      }}>
      <DialogTitle>
        Relatorio Lista de Treinamentos
      </DialogTitle>

      <DialogContent>
        <FormContainer title={"Informações"} arrangement="fullRow">
          <>
            {/* Campo 1: Sempre visível */}
            <DefaultFormAutocomplete
              name='dataRealizacao'
              label='Data Realização'
              options={datas}
              required={true}
              getOptionKey={(x) => x.valor}
              getOptionLabel={(x) => dayjs.utc(x.descricao).local().format('DD/MM/YYYY')}
              reactHookForm={reactHookForm} 
            />

            {dataRealizacaoSelected && (
              <DefaultFormAutocomplete
                name='instrutor'
                label='Instrutor'
                options={instrutores}
                required={true}
                getOptionKey={(x) => x.instrutor}
                getOptionLabel={(x) => x.instrutor}
                reactHookForm={reactHookForm} 
              />
            )}

            {dataRealizacaoSelected && instrutorSelected && (
              <DefaultFormAutocomplete
                name='local'
                label='Local'
                options={locais}
                required={true}
                getOptionKey={(x) => x.local}
                getOptionLabel={(x) => x.local}
                reactHookForm={reactHookForm} 
              />
            )}

            <FormSelectInput
              name='conteudoProgramatico'
              options={[{ id: 0, label: 'Não' }, { id: 1, label: 'Sim' }]}
              label='Exibir Conteúdo Programático'
              initialOptionId={0}
              showSelectionLabel={false}
              reactHookForm={reactHookForm} 
            />
          </>
        </FormContainer>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-end flex p-4 gap-4">
          <div className="flex flex-row gap-2">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1
                className="text-sm text-black dark:text-white"
                onClick={handleClose}>
                Cancelar
              </h1>
            </div>

            <div className="w-[120px]">
              {saving ? (
                  <PrimaryButton buttonColor="primary-green">
                    Gerando...
                  </PrimaryButton>
                ) : (
                  <PrimaryButton type="submit" buttonColor="primary-green">
                    Gerar
                  </PrimaryButton>
                )
              }
            </div>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}
